// extracted by mini-css-extract-plugin
export default {"nameLink":"TemplatesTable_nameLink__75wTW","nameButton":"TemplatesTable_nameButton__k47UV"};